import { useEffect, useState } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';
import { useAuth } from '../contexts/AuthContext';

// Returnerer Map<orderId, { bidId, amount }> for sjåførens egne bud
export function useDriverBids() {
  const { currentUser } = useAuth();
  const [driverBids, setDriverBids] = useState(new Map());

  useEffect(() => {
    if (!currentUser) return;
    const q = query(
      collection(db, 'bids'),
      where('driverUid', '==', currentUser.uid)
    );
    return onSnapshot(q, snap => {
      const map = new Map();
      snap.docs.forEach(d => {
        map.set(d.data().orderId, { bidId: d.id, amount: d.data().amount });
      });
      setDriverBids(map);
    });
  }, [currentUser]);

  return driverBids; // Map<orderId, { bidId, amount }>
}
